export const NEWS_KEY = 'a52fa6c481a146f88b2ba0a71d19a44b';
export const ALAN_KEY =
  'd83d849f11c00b950ad732bac54395682e956eca572e1d8b807a3e2338fdd0dc/stage';
